import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-abteilungsub-list-view',
  imports: [],
  templateUrl: './abteilungsub.list-view.html',
  styleUrls: ['./abteilungsub.list-view.css'],
})
export class AbteilungsubListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
